import { render, staticRenderFns } from "./PersonnelSelection.vue?vue&type=template&id=4d12d8f3&scoped=true"
import script from "./PersonnelSelection.vue?vue&type=script&lang=js"
export * from "./PersonnelSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d12d8f3",
  null
  
)

export default component.exports